// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"196":"async-graph","583":"async-plotlyjs","682":"async-mathjax"}[chunkId] + ".js";
};